import React, { useState } from 'react';
import * as Icons from 'react-icons/fa';

const HarmReduction: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="mt-6 mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center text-sm text-purple-400 hover:text-purple-300"
      >
        {React.createElement(Icons.FaInfoCircle, { className: "mr-2" })}
        <span>Harm reduction information</span>
      </button>
      
      {isOpen && (
        <div className="mt-3 bg-gray-800/80 p-4 rounded-lg text-sm text-gray-300 border border-gray-700">
          <h3 className="text-white font-bold mb-2">Safety first</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Always know what you're taking. Consider using test kits to verify substances.</li>
            <li>Start with low doses, especially with new substances or after breaks.</li>
            <li>Avoid mixing multiple substances, particularly those with similar effects.</li>
            <li>Stay hydrated, but don't overdo it (especially with MDMA).</li>
            <li>Have a sober friend present or inform someone you trust about your activities.</li>
            <li>Create a comfortable, safe environment before consumption.</li>
          </ul>
          
          <h3 className="text-white font-bold mt-4 mb-2">Helpful resources</h3>
          
          <a 
            href="https://psychonautwiki.org/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center hover:text-purple-400"
          >
            {React.createElement(Icons.FaExternalLinkAlt, { className: "mr-2 text-xs" })}
            PsychonautWiki - Detailed substance information
          </a>
          <a 
            href="https://tripsit.me/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center hover:text-purple-400"
          >
            {React.createElement(Icons.FaExternalLinkAlt, { className: "mr-2 text-xs" })}
            TripSit - Harm reduction chat and resources
          </a>
          <a 
            href="https://www.erowid.org/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center hover:text-purple-400"
          >
            {React.createElement(Icons.FaExternalLinkAlt, { className: "mr-2 text-xs" })}
            Erowid - Experience vaults and substance library
          </a>
          
          
        </div>
      )}
    </div>
  );
};

export default HarmReduction; 